import {decrypt, encrypt} from '@shared/utils/LocalStorage';

class Storage {
  static KEYS = {
    AUTH_TOKEN: 'AUTH_TOKEN',
    SELECTED_MODULE_NAME: 'SELECTED_MODULE_NAME',
    SELECTED_CHECK_BOX: 'SELECTED_CHECKBOX_DATA',
    SELECTED_CHECKBOX_LIST: 'SELECTED_CHECKBOX_LIST',
    SELECTED_PATIENT_ACCOUNTING_CHECK_BOX:
      'SELECTED_PATIENT_ACCOUNTING_CHECKBOX_DATA',
    SELECTED_PATIENT_ACCOUNTING_CHECKBOX_LIST:
      'SELECTED_PATIENT_ACCOUNTING_CHECKBOX_LIST',
    SELECTED_ADDITIONAL_CHECK_BOX: 'SELECTED_ADDITIONAL_CHECKBOX_DATA',
    SELECTED_ADDITIONAL_CHECKBOX_LIST: 'SELECTED_ADDITIONAL_CHECKBOX_LIST',
    SELECTED_LOGIN_TYPE: 'SELECTED_LOGIN_TYPE',
    IS_AZURE_AUTHENTICATED: 'IS_AZURE_AUTHENTICATED',
    IS_AZURE_REDIRECTED: 'IS_AZURE_REDIRECTED',
    EPIC_TOKEN_URL: 'EPIC_TOKEN_URL',
    ATHENA_TOKEN_URL: 'ATHENA_TOKEN_URL',
    DOC_ID: 'DOC_ID',
    USER_GROUP: 'USER_ACCESS',
    EPIC_PATIENT_ID: 'EPIC_PATIENT_ID',
    ATHENA_PATIENT_ID: 'ATHENA_PATIENT_ID',
    AUDIT_IDENTIFIER: 'AUDIT_IDENTIFIER',
    AUDIT_IDENTIFIER_TYPE: 'AUDIT_IDENTIFIER_TYPE',
    AUDIT_LEGACY_APP: 'AUDIT_LEGACY_APP',
    PREV_ROUTE: 'PREV_ROUTE',
    PERMISSIONS: 'PERMISSIONS',
    USER_APP_PERMISSION: 'USER_APP_PERMISSION',
    REDIRECT_ROUTE: 'REDIRECT_ROUTE',
    APPLICATION_NAME: 'APPLICATION_NAME',
    HOSPITAL_ID: 'HOSPITAL_ID'
  };

  static setItem = (key: string, value: any): void => {
    if (!value) {
      value = '';
    }
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(encrypt(key), encrypt(value));
  };

  static getItem = (key: string, shouldParse?: boolean): string | null => {
    const keyVal = decrypt(localStorage.getItem(Storage.searchKey(key)));
    if (shouldParse && keyVal) {
      return JSON.parse(keyVal);
    }
    return keyVal;
  };

  static searchKey(key: string): string {
    const keys = Object.keys(localStorage);
    let i = keys.length;
    while (i--) {
      try {
        if (decrypt(keys[i]) === key) {
          return keys[i];
        }
      } catch (e) {
        localStorage.removeItem(keys[i]);
      }
    }
    return '';
  }

  static removeItem = (key: string): void => {
    localStorage.removeItem(Storage.searchKey(key));
  };

  static clear = (): void => {
    localStorage.clear();
  };

  static sessionClear = (): void => {
    sessionStorage.clear();
  };

  static printStorage = (): void => {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      try {
        console.log(
          'Key:',
          decrypt(key),
          'Value:',
          decrypt(localStorage.getItem(key))
        );
      } catch (e) {
        console.log('Key:', key, 'Value: Unable to decrypt');
      }
    });
  };
}

export default Storage;
